// extracted by mini-css-extract-plugin
module.exports = {"banner":"DashboardBanner_banner__1UNrl"};